import * as React from 'react';
import { constants } from '../../../constants/index';
import OuterBarChartContainer from './OuterBarChartContainer';
import moment from 'moment-timezone';

const PercentBarChart = (props) => {
    const barHight = (props.barHeight) ? props.barHeight : 15;
    const barColor = constants.color.primaryDark;

    return (
        <OuterBarChartContainer
            borderColor= {barColor}
        >
            <div style={{ height: barHight, width:`${props.percentage}%`, backgroundColor: `${barColor}` }}/>
        </OuterBarChartContainer>
    ); 
  };

  export default PercentBarChart;


// WEBPACK FOOTER //
// ./src/js/components/DataVisualization/PercentBarChart/PercentBarChart.jsx